export enum TradingGroupIsDefaultTypesEnum {
    All = 1,
    Yes,
    No
}
